import React from 'react';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import Select from 'react-select';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import 'react-select/dist/react-select.css';

import CategoryApi from 'apis/Category';

var MultiSelectField = createClass({
  propTypes: {
    label: PropTypes.string,
  },
  getInitialState() {
    return {
      removeSelected: true,
      stayOpen: false,
      isLoading: true,
      value: [],
      categories: [],
    };
  },

  componentWillMount() {
    this.fetchCategories();
  },

  fetchCategories() {
    CategoryApi.getAll()
      .then(({ data }) => {
        this.setState({ categories: data, isLoading: false })
      })
      .catch(e => (toast.error(() => <div><FontAwesomeIcon icon="exclamation-triangle" />Error while fetching data</div>), console.log(e)))
  },

  render() {
    const { removeSelected, isLoading } = this.state;
    const { handleSelectChange, handleFocusOutCategory, value } = this.props;
    const options = this.state.categories.map((category) => {
      const array = { "label": category.name, "value": category.id }
      return array;
    })

    return (
      <div className="section">
        <Select
          multi
          onChange={handleSelectChange}
          isLoading={isLoading}
          onBlur={handleFocusOutCategory}
          options={options}
          placeholder="Select category"
          removeSelected={removeSelected}
          simpleValue
          value={value}
          required
        />
      </div>
    );
  }
});
export default MultiSelectField;



// WEBPACK FOOTER //
// ./src/components/businesses/MultiSelectField.js